/**
 * @module types/settings/tooltipSetting
 * @description 浮窗配置（存储字段名 `tooltipSetting`）
 */

export interface ITooltipExtraItem {
  type: 'text' | 'field';
  value: string;
  label?: string;
  tableCode?: string;
  column?: string;
  key?: string;
}

/** 与图表配置中 tooltipSetting 子集一致 */
export interface IToolTipSettingValue {
  showTotal?: boolean;
  showShare?: boolean;
  tooltipExtra?: ITooltipExtraItem[];
}

const TOOLTIP_EXTRA_EMPTY: ITooltipExtraItem[] = Object.freeze(
  [],
) as ITooltipExtraItem[];

/**
 * tooltipSetting 缺省：展示合计/占比，无额外内容
 *
 * @stable 须与 STRUCTURED_SETTING_DEFAULTS.tooltipSetting 为同一引用语义
 */
export const TOOLTIP_SETTING_DEFAULT: IToolTipSettingValue = Object.freeze({
  showTotal: true,
  showShare: true,
  tooltipExtra: TOOLTIP_EXTRA_EMPTY,
}) as IToolTipSettingValue;
